import { ScrollingModule } from '@angular/cdk/scrolling';
import { AsyncPipe, DecimalPipe, formatCurrency, formatDate, formatNumber, NgForOf, NgIf, NgTemplateOutlet } from '@angular/common';
import {
    ChangeDetectionStrategy,
    Component,
    ElementRef,
    inject,
    Inject,
    Input,
    OnDestroy,
    Optional,
    TemplateRef,
    ViewChild,
} from '@angular/core';
import { FormControl,FormGroup,FormsModule,ReactiveFormsModule,Validators } from '@angular/forms';
import { MatBadgeModule } from '@angular/material/badge';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatLegacyAutocompleteModule as MatAutocompleteModule } from '@angular/material/legacy-autocomplete';
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';
import { MatLegacyCardModule as MatCardModule } from '@angular/material/legacy-card';
import { MatLegacyOptionModule as MatOptionModule } from '@angular/material/legacy-core';
import {
MatLegacyDialog as MatDialog,
MatLegacyDialogConfig as MatDialogConfig,
MatLegacyDialogModule as MatDialogModule,
MatLegacyDialogRef as MatDialogRef,
MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA
} from '@angular/material/legacy-dialog';
import { MatLegacyFormFieldModule as MatFormFieldModule } from '@angular/material/legacy-form-field';
import { MatLegacyInputModule as MatInputModule } from '@angular/material/legacy-input';
import { MatLegacyListModule as MatListModule } from '@angular/material/legacy-list';
import { MatLegacyMenuModule as MatMenuModule } from '@angular/material/legacy-menu';
import { LegacyPageEvent as PageEvent,MatLegacyPaginator as MatPaginator,MatLegacyPaginatorModule as MatPaginatorModule } from '@angular/material/legacy-paginator';
import { MatLegacySelectModule as MatSelectModule } from '@angular/material/legacy-select';
import { MatLegacyTableDataSource,MatLegacyTableModule as MatTableModule } from '@angular/material/legacy-table';
import { MatLegacyTabsModule as MatTabsModule } from '@angular/material/legacy-tabs';
import { MatLegacyTooltipModule as MatTooltipModule } from '@angular/material/legacy-tooltip';
import { MatTabChangeEvent } from '@angular/material/tabs';
import { RouterLink } from '@angular/router';
import { GetTimestampFromTime } from '@dave/types/dist/convert';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { Store } from '@ngrx/store';
import moment,{ Moment } from 'moment';
import { TableVirtualScrollModule } from 'ng-table-virtual-scroll';
import { BehaviorSubject,combineLatest,firstValueFrom,from,Observable,of,switchMap } from 'rxjs';
import { catchError, distinctUntilChanged, filter, first, map, shareReplay, startWith, take } from 'rxjs/operators';
import {
    AccountsReceivableLedgerEntity,
    AccountsReceivableLedgerTypeEnum,
    financialRound,
} from '../../../dave-data-module/entities/accounts-receivable-ledger.entity';

import {
    LedgerImportDocumentTypeNames,
    LedgerImportDocumentTypes,
    LedgerImportEntity,
    LedgerImportStatusEnum,
} from '../../../dave-data-module/entities/ledger-import.entity';
import { MaterialListEntity } from '../../../dave-data-module/entities/material-list.entity';
import { MaterialToCommissionEntity,WorkTypeEnum } from '../../../dave-data-module/entities/material-to-commission.entity';
import { MaterialEntity } from '../../../dave-data-module/entities/material.entity';
import { AccountsReceivableLedgerResolver } from '../../../dave-data-module/guards/accounts-receivable-ledger.resolver';
import { MaterialListResolver } from '../../../dave-data-module/guards/material-list.resolver';
import { QuantityTypeResolver } from '../../../dave-data-module/guards/quantity-type.resolver';
import { getFetched$ } from '../../../dave-data-module/helper/helper';
import { ArlDataService } from '../../../dave-data-module/services/arl-data.service';
import { MaterialDataService } from '../../../dave-data-module/services/material-data.service';
import { PaginatedMaterialService } from '../../../dave-data-module/services/paginated-material.service';
import { State } from '../../../dave-data-module/State';
import { MaterialToCommissionActionTypes } from '../../../dave-data-module/State/actions/material-to-commission.actions';
import {
    getAccountsReceivableLedgerById, getAccountsReceivableLedgerDictionary,
    getQuantityTypes,
    getQuantityTypesFetched,
} from '../../../dave-data-module/State/selectors/accounting.selector';
import { getCommissionById } from '../../../dave-data-module/State/selectors/commission.selector';
import {
getLedgerImportDictionary,
getLedgerImports,
getLedgerImportsFetched
} from '../../../dave-data-module/State/selectors/ledger-import.selector';
import { getMaterialLists,getMaterialListsFetched } from '../../../dave-data-module/State/selectors/material-list.selector';
import { getMaterialToCommission,getMaterialToCommissionById,getMaterialToCommissionFetched } from '../../../dave-data-module/State/selectors/resource-to-commission.selector';
import { getUserDictionary,getUsersFetched } from '../../../dave-data-module/State/selectors/users.selectors';
import { DaveDoubleIconModule } from '../../../dave-double-icon/dave-double-icon.module';
import { DaveListCardModule } from '../../../dave-list-card/dave-list-card.module';
import { DaveListModule } from '../../../dave-list/dave-list.module';
import { DaveLoadingModule } from '../../../dave-loading/dave-loading.module';
import { _getArlChildren } from '../../../dave-reports/components/arl-calculation/arl-calculation.helper';
import { AppButtonModule } from '../../../dave-utils-module/app-button-module/app-button.module';
import { AppFilterModule } from '../../../dave-utils-module/app-filter-module/app-filter.module';
import {
    FilterOption,
    FILTER_TYPE_MULTI_SELECT,
    IFilterTypeSearchMultiSelectValue, FILTER_TYPE_SEARCH_SELECT_BACKEND, FilterOptionSelectSearch,
    FILTER_TYPE_SEARCH_MULTI_SELECT, FILTER_TYPE_BOOLEAN,
} from '../../../dave-utils-module/app-filter-module/app-filter/app-filter.component';
import { IDetailListTemplateDataProperty } from '../../../dave-utils-module/dave-shared-components-module/components/detail-views/detail-list-template/detail-list-template.component';
import { DaveSharedComponentsModule } from '../../../dave-utils-module/dave-shared-components-module/dave-shared-components.module';
import {
CreateArlFromCommissionService
} from '../../../dave-utils-module/dave-shared-components-module/services/create-arl-from-commission-service';
import {
PermissionService
} from '../../../dave-utils-module/dave-shared-components-module/services/permission.service';
import { SelectSearchPagedOptionsComponent } from '../../../dave-utils-module/select-search/components/select-search-paged-options/select-search-paged-options.component';
import { SelectSearchOption } from '../../../dave-utils-module/select-search/components/select-search/select-search.component';
import { SelectSearchModule } from '../../../dave-utils-module/select-search/select-search.module';
import { DetailListDialogReturn,DetailListTemplateDialogComponent,DetailListTemplateDialogData } from '../../../detail-list-template-dialog/components/detail-list-template-dialog.component';
import {
    appMatDialogDefaultConfig, compareArrays,
    compareEqualityAsJsonString, compareMaps, isNotNullOrUndefined, sortByDateProperty, uniqArray,
} from '../../../helper/helper';
import { AllReportsMeta,MaterialPageMeta,ReportsPageMeta } from '../../../helper/page-metadata';
import { FilterTypes } from '../../../services/default-filter.service';
import { SelectMaterialPopupComponent,SelectMaterialPopupComponentDialogData } from '../select-material-popup/select-material-popup.component';
import { CustomLabelService } from '../../../services/custom-label/custom-label.service';
import {
    getCustomerDictionary,
    getNotDeletedSuppliers,
} from '../../../dave-data-module/State/selectors/customers.selectors';
import {
    getEmployeesActiveSortedByNameStartWithMe
} from '../../../dave-data-module/State/selectors/employees.selectors';
import { getOwnPartnerOffices, getPartner } from '../../../dave-data-module/State/selectors/partners.selectors';
import { getStatusFromBackoffice } from '../../../dave-data-module/State/selectors/statusFromBackoffice.selectors';
import { getCommissionTypes } from '../../../dave-data-module/State/selectors/commissionType.selectors';
import { getDepartmentsActive } from '../../../dave-data-module/State/selectors/department.selector';
import { CustomerEntity } from '../../../dave-data-module/entities/customer.entity';
import { CustomerDataService } from '../../../dave-data-module/services/customer-data.service';
import { LedgerImportDataService } from '../../../dave-data-module/services/ledger-import-data.service';

const MATERIAL_LIST_TAB_INDEX = 0;
const DELIVERYNOTE_LIST_TAB_INDEX: number = 1;
interface MaterialListData {
    MaterialName: string;
    MaterialId: number;
    QuantityType: string;
    Quantity: number;
    CreatedAt: string;
    User: string;
    Status: string;
    ArticleNumber: string;
    SupplierName: string;
}
interface MaterialListDataGrouped {
    material: MaterialEntity | null;
    materialName: string;
    sum: number;
    orderedSum: number;
    orderLedgerImports$: Observable<LedgerImportEntity[]>;
    materialLists$: Observable<MatLegacyTableDataSource<MaterialListData>>;
}
interface MaterialToCommissionTableData {
    QuantityType: string;
    MaterialToCommissionId: number;
    Quantity: number;
    Name: string;
    Description: string | null;
    Date: string;
    DateValue: number;
    User: string;
    ArticleNumber: string;
    DocumentType: string;
    SupplierName: string;
    LedgerImportId: number | null
    CostAmount: number;
    CostAmountSum: number;
    IsOrder: boolean;
    SupplierId: number | null;
}
interface MaterialToCommissionData {
    MaterialName: string;
    MaterialId: number;
    ArticleNumber: string | null;
    QuantityType: string | null;
    OrderedSum: number;
    DeliverySum: number;
    CostAmountSum: number;
    m2cs: MaterialToCommissionTableData[];
}

export interface MaterialListComponentDialogData {
    CommissionId: number;
}
// has to be string because the filter will cast it to string anyway
enum orderStatus {
    nothing = 'nothing',
    less = 'less',
    greaterOrEqual = 'greaterOrEqual',
}
interface MaterialListListFilter {
    [FilterTypes.OrderedStatus]: Array<orderStatus>;
}
@Component({
    selector: 'app-material-list',
    templateUrl: './material-list.component.html',
    styleUrls: ['./material-list.component.scss'],
    standalone: true,
    imports: [
        AppButtonModule,
        FontAwesomeModule,
        MatTabsModule,
        AsyncPipe,
        DaveDoubleIconModule,
        DaveListCardModule,
        MatTooltipModule,
        FormsModule,
        MatFormFieldModule,
        MatInputModule,
        MatListModule,
        DaveListModule,
        MatDialogModule,
        MatTableModule,
        NgIf,
        DaveLoadingModule,
        ScrollingModule,
        TableVirtualScrollModule,
        DaveSharedComponentsModule,
        MatExpansionModule,
        MatCardModule,
        NgTemplateOutlet,
        MatButtonModule,
        ReactiveFormsModule,
        MatOptionModule,
        MatAutocompleteModule,
        MatSelectModule,
        MatMenuModule,
        NgForOf,
        SelectSearchPagedOptionsComponent,
        SelectSearchModule,
        MatPaginatorModule,
        AppFilterModule,
        MatBadgeModule,
        RouterLink,
        DecimalPipe,
    ],
    providers: [PaginatedMaterialService],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class MaterialListComponent implements OnDestroy {
    public static DefaultConfig: MatDialogConfig = {
        ...appMatDialogDefaultConfig,
        panelClass: 'no-padding-dialog',
        width: '90vw',
        height: '90vh',
    };
    private commissionId$ = new BehaviorSubject<number | null>(null);
    @Input() set CommissionId(id: number) {
        if (id !== this.commissionId$.value) {
            this.commissionId$.next(id);
        }
    }
    @ViewChild('pagedSelectTest') pagedSelectTest: TemplateRef<any>;
    @Input() Expanded = true;
    @Input() Expandable = false;
    protected searchForm = new FormControl<string>('');
    protected searchVisible = false;
    @ViewChild('searchInput') searchInput: ElementRef;
    public MaterialColumns: Array<keyof MaterialListData> = [/*'MaterialName',*/ 'ArticleNumber', 'Quantity', 'QuantityType', 'CreatedAt', 'SupplierName'];
    public MaterialToCommissionColumns: Array<keyof MaterialToCommissionTableData | 'editButton'> = ['ArticleNumber', 'Description', 'Name', 'Date', 'Quantity', 'QuantityType', 'DocumentType', 'SupplierName' /*'QuantityType', 'User'*/, 'CostAmount', 'CostAmountSum', 'editButton'];
    public visibility = { Lieferant: true, Status: true, User: true };
    public LedgerImportRouterLinkPrefix = '/' + ReportsPageMeta.Path + '/' + AllReportsMeta.Path + '/';
    // private materials$: Observable<MaterialEntity[]>;
    protected _materialPageService = inject(PaginatedMaterialService);
    private _materialDataService = inject(MaterialDataService);
    protected FilterSettings$: Observable<FilterOption[]> = of([
        {
            Name: FilterTypes.OrderedStatus,
            Label: 'Bestellstatus',
            Type: FILTER_TYPE_MULTI_SELECT,
            Values: {
                [orderStatus.nothing]: 'nicht bestellt',
                [orderStatus.less]: 'zu wenig bestellt',
                [orderStatus.greaterOrEqual]: 'passend oder mehr',
            },
        },
    ]);

    public SupplierFilterSettings$: Observable<FilterOption[]> = this.cls.getSingle$('Supplier').pipe(
        map((supplierLabel) => {
            const customerState = this.customerDataService.createSearchState({ onlySuppliers: true });

            const ret: FilterOption[] = [
                {
                    Name: FilterTypes.Customers,
                    Type: FILTER_TYPE_SEARCH_SELECT_BACKEND,
                    Label: supplierLabel,
                    SelectSearch: {
                        options$: customerState.customerOptions$,
                        loading$: customerState.loading$,
                        pageIndex$: customerState.customerPaging.pageIndex$,
                        pageCount$: customerState.customerPaging.pageCount$,

                        getIdFromValue: (c) => c.Id,
                        getValueFromId: (id) => this.customerDataService.GetSingleCustomer$(id),

                        serverSearch: (search) => customerState.SearchCustomers(search, 'unbenannter ' + supplierLabel),
                        pageChange: (event) => customerState.customerPageChange(event),
                        compareOptions: (a, b) => a?.Id === b?.Id,
                    } as FilterOptionSelectSearch<CustomerEntity>,
                },
            ];

            return ret;
        }),
    );

    protected  SupplierFilterValues$: BehaviorSubject<{
        [FilterTypes.Customers]: number|null;
    }> = new BehaviorSubject({
        [FilterTypes.Customers]: null,
    });


    public SupplierFilterAmount$ = this.SupplierFilterValues$.pipe(
        map((val) => {
            let filterAmount = 0;
            for (const [key, value] of Object.entries(val)) {
                if (key === FilterTypes.Customers && value !== null) {
                    filterAmount++;
                }
            }
            return filterAmount;
        }),
        shareReplay({ refCount: true, bufferSize: 1 }),
    );

    protected FilterValues$: BehaviorSubject<MaterialListListFilter> = new BehaviorSubject({
        [FilterTypes.OrderedStatus]: null,
    });
    protected FilterAmount$ = this.FilterValues$.pipe(
        map((val) => {
            let filterAmount = 0;
            for (const [key, value] of Object.entries(val)) {
                if (value && `${value}` !== '-' && (value.length === undefined || value.length)) {
                    filterAmount++;
                }
            }
            return filterAmount;
        }),
        shareReplay({ refCount: true, bufferSize: 1 }),
    );


    constructor(
        @Optional() @Inject(MAT_DIALOG_DATA) public DialogData: MaterialListComponentDialogData,
        @Optional() protected dialogRef: MatDialogRef<MaterialListComponent>,
        private store: Store<State>,
        private dialog: MatDialog,
        quantityTypeResolver: QuantityTypeResolver,
        materialListResolver: MaterialListResolver,
        public PS: PermissionService,
        private createArlFromCommissionService: CreateArlFromCommissionService,
        protected arlDataService: ArlDataService,
        protected cls: CustomLabelService,
        private customerDataService: CustomerDataService,
        private ledgerImportDataService: LedgerImportDataService,
    ) {
        firstValueFrom(this.store.select(getQuantityTypesFetched)).then((fetched) => {
            if (!fetched) {
                quantityTypeResolver.resolve();
            }
        });
        firstValueFrom(this.store.select(getMaterialListsFetched)).then((fetched) => {
            if (!fetched) {
                materialListResolver.resolve();
            }
        });

        if (DialogData) {
            this.CommissionId = DialogData.CommissionId;
        }
    }
    ngOnDestroy(): void {
        this.commissionId$.complete();
        this.FilterValues$.complete();
        this.SupplierFilterValues$.complete();
    }

    private filteredMaterialLists$ = this.commissionId$.pipe(
        filter(isNotNullOrUndefined),
        switchMap((commissionId) => {
            return getFetched$(this.store, getMaterialListsFetched, getMaterialLists).pipe(map((materialList) => materialList.filter((mListEntry) => mListEntry.CommissionId === commissionId && !mListEntry.DeletedAt)));
        }),
        shareReplay({ refCount: true, bufferSize: 1 }),
    );

    private ledgerImportsLoaded$ = this.commissionId$.pipe(
        filter(isNotNullOrUndefined),
        switchMap((commissionId) =>
            from(this.ledgerImportDataService.getLedgerImportsFromCommissions$([commissionId])).pipe(
                catchError(() => of(null)),
                map(() => true),
            ),
        ),
        shareReplay({ refCount: true, bufferSize: 1 }),
    );
    private ledgerImports$ = this.ledgerImportsLoaded$.pipe(switchMap(() => this.store.select(getLedgerImports)));
    private ledgerImportDictionary$ = this.ledgerImportsLoaded$.pipe(switchMap(() => this.store.select(getLedgerImportDictionary)));

    private arlsBase$ = this.commissionId$.pipe(
        switchMap((commissionid) =>
            this.ledgerImports$.pipe(
                map((ledgerImports) => {
                    const filteredLedgerImports = ledgerImports.filter((li) =>
                        li.CommissionId === commissionid &&
                        (
                            li.DocumentType === LedgerImportDocumentTypes.Order ||
                            li.DocumentType === LedgerImportDocumentTypes.DeliveryNote ||
                            li.DocumentType === LedgerImportDocumentTypes.ReturnDeliveryNote
                        ) &&
                        li.AccountsReceivableLedgerIds.length > 0
                    );

                    return filteredLedgerImports
                }),
                distinctUntilChanged((a, b) => a?.length === b?.length && a.every((li, index) => li.Id === b[index].Id && li.UpdatedAt.getTime() === b[index].UpdatedAt.getTime())),
                switchMap((filteredLedgerImports) => {
                    return this.arlDataService.getARLsForLedgerImports$(filteredLedgerImports.map((li) => li.Id)).pipe(
                        map((arls) => {
                            const rootArlIds = filteredLedgerImports.map((l) => l.AccountsReceivableLedgerIds).flat();
                            const orderArls = rootArlIds.map((id) => _getArlChildren(id, arls, false)).flat();
                            return orderArls;
                        }),
                    );
                }),
            ),
        ),
        shareReplay({ refCount: true, bufferSize: 1 }),
    );

    private supplierNameByArlId$: Observable<Map<number, string>> = combineLatest([
        this.arlsBase$,
        this.ledgerImportDictionary$,
    ]).pipe(
        map(([arls, ledgerImports]) => {
            const supplierIdByArlId = new Map<number, number>();
            for (const arl of arls) {
                const supplierId = arl.SupplierId ?? (arl.LedgerImportId ? ledgerImports[arl.LedgerImportId]?.CustomerId : null);
                if (supplierId) {
                    supplierIdByArlId.set(arl.Id, supplierId);
                }
            }
            return supplierIdByArlId;
        }),
        distinctUntilChanged((a, b) => compareMaps(a, b)),
        switchMap((supplierIdByArlId) => {
            const supplierIds = uniqArray([...supplierIdByArlId.values()]);
            if (!supplierIds.length) {
                return of(new Map<number, string>());
            }
            return this.customerDataService.GetCustomers$(supplierIds, true).pipe(take(1)).pipe(
                map((customers) => {
                    const nameById = new Map(customers.filter(isNotNullOrUndefined).map((c) => [c.Id, c.DisplayName] as [number, string]));
                    const result = new Map<number, string>();
                    supplierIdByArlId.forEach((supplierId, arlId) => {
                        const name = nameById.get(supplierId);
                        if (name) {
                            result.set(arlId, name);
                        }
                    });
                    return result;
                }),
            );
        }),
        shareReplay({ refCount: true, bufferSize: 1 }),
    );

    private supplierIdByArlId$: Observable<Map<number, number>> = combineLatest([
        this.arlsBase$,
        this.ledgerImportDictionary$,
    ]).pipe(
        map(([arls, ledgerImports]) => {
            const result = new Map<number, number>();
            for (const arl of arls) {
                const supplierId = arl.SupplierId ?? (arl.LedgerImportId ? ledgerImports[arl.LedgerImportId]?.CustomerId : null);
                if (supplierId) {
                    result.set(arl.Id, supplierId);
                }
            }
            return result;
        }),
        shareReplay({ refCount: true, bufferSize: 1 }),
    );

    private orderedMaterialArls$ = this.arlsBase$.pipe(
        map((baseArls) => {
            const orderArls = baseArls.filter((arl) => arl.DocumentType === LedgerImportDocumentTypes.Order);
            return orderArls.filter((arl) => arl.MaterialId && arl.Type === AccountsReceivableLedgerTypeEnum.MaterialArl && arl.Quantity);
        }),
        shareReplay({ refCount: true, bufferSize: 1 }),
    );
    // private _getARLsFromLedgerImportType$ = () this.commissionId$.pipe()
    private paidMaterialArls$ = combineLatest([
        this.commissionId$,
        this.ledgerImports$,
        // this.arlDataService.getAllArlsAsDict(false)
    ]).pipe(
        switchMap(([commissionid, ledgerImports]) => {
            const filteredLedgerImports = ledgerImports.filter(
                (li) =>
                    li.CommissionId === commissionid &&
                    (li.Status === LedgerImportStatusEnum.Versandt || li.Status === LedgerImportStatusEnum.Gebucht || li.Status === LedgerImportStatusEnum.Verrechnet) &&
                    (li.DocumentType === LedgerImportDocumentTypes.Invoice || li.DocumentType === LedgerImportDocumentTypes.PartialInvoice || li.DocumentType === LedgerImportDocumentTypes.ClosingInvoice) &&
                    li.AccountsReceivableLedgerIds.length > 0,
            );
            return this.arlDataService.getARLsForLedgerImports$(filteredLedgerImports.map((li) => li.Id)).pipe(
                map((arls) => {
                    const rootArlIds = filteredLedgerImports.map((l) => l.AccountsReceivableLedgerIds).flat();
                    const invoiceArls = rootArlIds.map((id) => _getArlChildren(id, arls, false)).flat();
                    return invoiceArls.filter((arl) => arl.MaterialId && arl.Type === AccountsReceivableLedgerTypeEnum.MaterialArl && arl.Quantity);
                }),
            );
        }),
        shareReplay({ refCount: true, bufferSize: 1 }),
    );





    private filteredMaterialToCommissions$ = this.commissionId$.pipe(
        filter(isNotNullOrUndefined),
        switchMap((commissionId) =>
            getFetched$(this.store, getMaterialToCommissionFetched, getMaterialToCommission).pipe(map((m2c) => m2c.filter((m) => m.CommissionId === commissionId && !m.DeletedAt && m.WorkType !== WorkTypeEnum.FreeWork))),
        ),
        shareReplay({ refCount: true, bufferSize: 1 }),
    );

    protected hasMaterialLists$ = this.filteredMaterialLists$.pipe(
        map((materialLists) => materialLists.length > 0),
        distinctUntilChanged(),
        shareReplay({ refCount: true, bufferSize: 1 }),
    );
    protected hasMaterialToCommissions$ = combineLatest([this.filteredMaterialLists$, this.filteredMaterialToCommissions$]).pipe(
        map(([materialLists, materialToCommissions]) => materialLists.length > 0 || materialToCommissions.length > 0),
        distinctUntilChanged(),
        shareReplay({ refCount: true, bufferSize: 1 }),
    );
    private allNeededMaterialIds$ = combineLatest([
        this.filteredMaterialLists$,
        this.filteredMaterialToCommissions$,
    ]).pipe(
        map(([materialLists, materialToCommissions]) =>
            uniqArray([
                ...materialLists.map((ml) => ml.MaterialId),
                ...materialToCommissions.map((m) => m.MaterialId),
            ]).filter(isNotNullOrUndefined).sort(),
        ),
        distinctUntilChanged((a, b) => compareArrays(a, b)),
        shareReplay({ refCount: true, bufferSize: 1 }),
    );
    private materials$: Observable<MaterialEntity[]> = this.allNeededMaterialIds$.pipe(
        switchMap((ids) =>
            (ids.length ? this._materialDataService.getMaterialsById$(ids) : of([] as MaterialEntity[]))),
        shareReplay({ refCount: true, bufferSize: 1 }),
    );

    protected materialListsPaid$ = combineLatest([
        this.filteredMaterialLists$,
        this.filteredMaterialLists$.pipe(switchMap((m) => (m.length ? this.paidMaterialArls$ : of([] as AccountsReceivableLedgerEntity[])))),
        this.materials$,
    ]).pipe(
        switchMap(([materialLists, orderedMaterialArls, materials]) => {
            const materialListEntriesWithoutMaterial: MaterialListEntity[] = materialLists.filter((f) => !f.MaterialId);
            const materialListNamesWithoutMaterial: string[] = uniqArray(materialListEntriesWithoutMaterial.map((ml) => ml.ArlInformation));

            const relevantMaterialIds = new Set(materialLists.map((ml) => ml.MaterialId).filter(isNotNullOrUndefined));
            const relevantMaterials = materials.filter((m) => relevantMaterialIds.has(m.Id));

            const groupedMaterialDatasources = [
                ...relevantMaterials.map((material) => {
                    const materialListsByMaterial = materialLists.filter((ml) => ml.MaterialId === material.Id);
                    const invoiceArls = orderedMaterialArls.filter((arl) => arl.MaterialId === material.Id);
                    const invoiceLedgerImportIds = uniqArray(invoiceArls.map((arl) => arl.LedgerImportId));
                    const inVoiceLedgerImports$ = invoiceLedgerImportIds.length
                        ? this.store.select(getLedgerImportDictionary).pipe(map((lis) => invoiceLedgerImportIds.map((id) => lis[id]).filter(isNotNullOrUndefined)))
                        : of([]);

                    return {
                        material,
                        materialName: material?.Name,
                        sum: materialListsByMaterial.reduce((p, c) => p + (c.Amount || 0), 0),
                        paidSum: invoiceArls.reduce((p, c) => p + (c.Quantity || 0), 0),
                        inVoiceLedgerImports$,
                        materialLists$: this.getMaterialListDataSource(material?.Name, material?.Id, material?.ArticleNumber, material?.QuantityTypeId, materialListsByMaterial),
                    };
                }),
                ...materialListNamesWithoutMaterial.map(name => {
                    const materialListsByName = materialListEntriesWithoutMaterial.filter((ml) => ml.ArlInformation === name);
                    const invoiceArls = orderedMaterialArls.filter((arl) => !arl.MaterialId && arl.Information === name);

                    const invoiceLedgerImportIds = uniqArray(invoiceArls.map((arl) => arl.LedgerImportId));
                    const inVoiceLedgerImports$ = invoiceLedgerImportIds.length
                        ? this.store.select(getLedgerImportDictionary).pipe(map((lis) => invoiceLedgerImportIds.map((id) => lis[id]).filter(isNotNullOrUndefined)))
                        : of([]);

                    return {
                        material: null,
                        materialName: name,
                        sum: materialListsByName.reduce((p, c) => p + (c.Amount || 0), 0),
                        paidSum: invoiceArls.reduce((p, c) => p + (c.Quantity || 0), 0),
                        inVoiceLedgerImports$,
                        materialLists$: this.getMaterialListDataSource(name, null, null, null, materialListsByName),
                    };
                }),
            ];

            return this.FilterValues$.pipe(
                map((filter) => {
                    if (!filter || !filter[FilterTypes.OrderedStatus] || !filter[FilterTypes.OrderedStatus].length) {
                        return groupedMaterialDatasources;
                    }
                    return groupedMaterialDatasources.filter(
                        (d) =>
                            (!d.paidSum && filter[FilterTypes.OrderedStatus].includes(orderStatus.nothing)) ||
                            (d.sum > d.paidSum && filter[FilterTypes.OrderedStatus].includes(orderStatus.less)) ||
                            (d.sum <= d.paidSum && filter[FilterTypes.OrderedStatus].includes(orderStatus.greaterOrEqual)),
                    );
                }),
                switchMap((dataSource) =>
                    this.searchForm.valueChanges.pipe(
                        startWith(''),
                        map(() => (this.searchForm.value || '').trim().toLowerCase()),
                        map((searchTerm) => {
                            if (!searchTerm) return dataSource;

                            return dataSource.filter((data) => {
                                const material = data.material;
                                return (
                                    material?.Name?.toLowerCase().includes(searchTerm) ||
                                    material?.ArticleNumber?.toLowerCase().includes(searchTerm)
                                );
                            });
                        }),
                    ),
                ),
            );
        }),
        shareReplay({ refCount: true, bufferSize: 1 }),
    );

    protected materialListsGrouped$: Observable<MaterialListDataGrouped[]> = combineLatest([
        this.filteredMaterialLists$,
        this.filteredMaterialLists$.pipe(switchMap((m) => (m.length ? this.orderedMaterialArls$ : of([] as AccountsReceivableLedgerEntity[])))),
        this.arlsBase$,
        this.materials$,
    ]).pipe(
        switchMap(([filteredMaterialList, orderedMaterialArls, allOrderArls, materials]) => {

            const relevantMaterialIds = new Set(filteredMaterialList.map((ml) => ml.MaterialId));
            const relevantMaterials = materials.filter((m) => relevantMaterialIds.has(m.Id));

            const materialListEntriesWithoutMaterial = filteredMaterialList.filter((f) => !f.MaterialId);
            const materialListNamesWithoutMaterial = uniqArray(materialListEntriesWithoutMaterial.map((ml) => ml.ArlInformation));

            const groupedMaterialDatasources = [
                ...relevantMaterials.map((material) => {
                            const materialListsByMaterial = filteredMaterialList.filter((ml) => ml.MaterialId === material.Id);
                            const orderArls = orderedMaterialArls.filter((arl) => arl.MaterialId === material.Id);
                            const orderLedgerImportIds = uniqArray(orderArls.map((arl) => arl.LedgerImportId));
                            const orderLedgerImports$ = orderLedgerImportIds.length
                                ? this.store.select(getLedgerImportDictionary).pipe(map((lis) => orderLedgerImportIds.map((id) => lis[id]).filter(isNotNullOrUndefined)))
                                : of([] as LedgerImportEntity[]);

                            return {
                                material,
                                materialName: material.Name,
                                sum: materialListsByMaterial.reduce((p, c) => p + (c.Amount || 0), 0),
                                orderedSum: orderArls.reduce((p, c) => p + (c.Quantity || 0), 0),
                                orderLedgerImports$,
                                materialLists$: this.getMaterialListDataSource(material?.Name, material?.Id, material?.ArticleNumber, material?.QuantityTypeId, materialListsByMaterial),
                            };
                        }),
                        ...materialListNamesWithoutMaterial.map((name) => {
                            const materialListsByName = materialListEntriesWithoutMaterial.filter((ml) => ml.ArlInformation === name);
                            const orderArls = allOrderArls.filter((arl) => !arl.MaterialId && arl.Information === name);

                            const orderLedgerImportIds = uniqArray(orderArls.map((arl) => arl.LedgerImportId));
                            const orderLedgerImports$ = orderLedgerImportIds.length
                                ? this.store.select(getLedgerImportDictionary).pipe(map((lis) => orderLedgerImportIds.map((id) => lis[id]).filter(isNotNullOrUndefined)))
                                : of([] as LedgerImportEntity[]);

                            return {
                                material: null,
                                materialName: name,
                                sum: materialListsByName.reduce((p, c) => p + (c.Amount || 0), 0),
                                orderedSum: orderArls.reduce((p, c) => p + (c.Quantity || 0), 0),
                                orderLedgerImports$,
                                materialLists$: this.getMaterialListDataSource(name, null, null,null, materialListsByName),
                            };
                        }),
                    ];
                    return this.FilterValues$.pipe(
                        map((filter) => {
                            if (!filter || !filter[FilterTypes.OrderedStatus] || !filter[FilterTypes.OrderedStatus].length) {
                                return groupedMaterialDatasources;
                            }
                            console.log(filter);
                            return groupedMaterialDatasources.filter(
                                (d) =>
                                    (!d.orderedSum && filter[FilterTypes.OrderedStatus].includes(orderStatus.nothing)) ||
                                    (d.sum > d.orderedSum && filter[FilterTypes.OrderedStatus].includes(orderStatus.less)) ||
                                    (d.sum <= d.orderedSum && filter[FilterTypes.OrderedStatus].includes(orderStatus.greaterOrEqual)),
                            );
                        }),
                        switchMap((dataSource) =>
                            this.searchForm.valueChanges.pipe(
                                startWith(''),
                                map(() => (this.searchForm.value || '').trim().toLowerCase()),
                                map((searchTerm) => {
                                    if (!searchTerm) return dataSource;

                                    return dataSource.filter((data) => {
                                        const m = data.material;
                                        return (
                                            m?.Name?.trim().toLowerCase().includes(searchTerm) ||
                                            m?.ArticleNumber?.trim().toLowerCase().includes(searchTerm)
                                        );
                                    });
                                }),
                            ),
                        ),
                    );
                }),
                 shareReplay({ refCount: true, bufferSize: 1 }),
            );

    public materialToCommissions$: Observable<MaterialToCommissionData[]> = this.commissionId$.pipe(
        filter(isNotNullOrUndefined),
        switchMap((commissionId) =>
            combineLatest([
                getFetched$(this.store, getQuantityTypesFetched, getQuantityTypes),
                getFetched$(this.store, getUsersFetched, getUserDictionary),
                this.filteredMaterialLists$,
                combineLatest([this.filteredMaterialToCommissions$, this.filteredMaterialLists$]).pipe(
                    map(([filteredMaterialToCommissions, filteredMaterialList]) =>
                        uniqArray([...filteredMaterialToCommissions.map((f) => f.MaterialId), ...filteredMaterialList.map((f) => f.MaterialId)])
                            .filter(isNotNullOrUndefined)
                            .sort(),
                    ),
                    distinctUntilChanged((a, b) => compareArrays(a, b)),
                    switchMap((ids) =>
                        ids.length
                            ? this.materials$.pipe(map((materials) => materials.filter((m) => ids.includes(m.Id))))
                            : of([] as MaterialEntity[]),
                    ),
                ),
                this.filteredMaterialToCommissions$,
                this.arlsBase$,
                this.ledgerImportDictionary$,
                this.supplierNameByArlId$,
                this.supplierIdByArlId$,
            ]),
        ),
        map(([quantityTypes, users, filteredMaterialList, materials, filteredMaterialToCommissions, arls, ledgerImports, supplierNames, supplierIds]) => {
            const materialListEntriesWithoutMaterial: MaterialListEntity[] = filteredMaterialList.filter((f) => !f.MaterialId);
            const materialToCommissionEntriesWithoutMaterial: MaterialToCommissionEntity[] = filteredMaterialToCommissions.filter((f) => !f.MaterialId);
            const arlMap = new Map(arls.map(arl => [arl.Id, arl]));
            const materialMap = new Map(materials.map(m => [m.Id, m]));
            const quantityTypeMap = new Map(quantityTypes.map(q => [q.Id, q]));
            const mapM2c = (m2c: MaterialToCommissionEntity) => {
                const arl = arlMap.get(m2c.ArlId);
                return {
                    IsOrder: false,
                    Name: m2c.Name,
                    Date: m2c.Date ? formatDate(m2c.Date, 'shortDate', 'de-DE') : '-',
                    DateValue: m2c.Date ? new Date(m2c.Date).getTime() : 0,
                    Quantity: m2c.Value,
                    Description: arl?.Information ?? materialMap.get(m2c.MaterialId)?.Name ?? null,
                    QuantityType: m2c.QuantityTypeId ? quantityTypeMap.get(m2c.QuantityTypeId)?.Name : null,
                    MaterialToCommissionId: m2c.Id,
                    User: users[m2c.UserId]?.DisplayName,
                    ArticleNumber: arl ? arl.BookingText ?? null : materialMap.get(m2c.MaterialId)?.ArticleNumber ?? null,
                    DocumentType: arl?.DocumentType ? LedgerImportDocumentTypeNames.get(arl.DocumentType as LedgerImportDocumentTypes) : null,
                    SupplierName: arl ? supplierNames.get(arl.Id) ?? null : null,
                    LedgerImportId: arl?.LedgerImportId ?? null,
                    CostAmount: arl?.CostAmount ?? 0,
                    CostAmountSum: arl?.CostAmount ? financialRound(arl?.CostAmount * m2c.Value) : 0,
                    SupplierId: arl ? supplierIds.get(arl.Id) ?? null : null,
                };
            };
            const mapOrder = (ml: MaterialListEntity, material: MaterialEntity | null): MaterialToCommissionTableData => {
                const arl = arlMap.get(ml.ArlId);
                const quantityTypeId = ml.ArlQuantityTypeId ?? material?.QuantityTypeId;
                return {
                    IsOrder: true,
                    Name: arl?.LedgerImportId ? ledgerImports[arl.LedgerImportId]?.ConsolidatedInvoiceId ?? null : null,
                    Date: ml.CreatedAt ? formatDate(ml.CreatedAt, 'shortDate', 'de-DE') : '-',
                    DateValue: ml.CreatedAt ? new Date(ml.CreatedAt).getTime() : 0,
                    Quantity: ml.Amount,
                    Description: arl?.Information ?? ml.ArlInformation ?? material?.Name ?? null,
                    QuantityType: quantityTypeId ? quantityTypeMap.get(quantityTypeId)?.Name : null,
                    MaterialToCommissionId: null,
                    User: users[ml.UserId]?.DisplayName,
                    ArticleNumber: arl ? arl.BookingText ?? null : material?.ArticleNumber ?? null,
                    DocumentType: arl?.DocumentType ? LedgerImportDocumentTypeNames.get(arl.DocumentType as LedgerImportDocumentTypes) : null,
                    SupplierName: arl ? supplierNames.get(arl.Id) ?? null : null,
                    LedgerImportId: arl?.LedgerImportId ?? null,
                    CostAmount: arl?.CostAmount ?? 0,
                    CostAmountSum: arl?.CostAmount ? financialRound(arl?.CostAmount * ml.Amount) :  0,
                    SupplierId: arl ? supplierIds.get(arl.Id) ?? null : null,
                };
            };


            const buildGroup = (
                materialName: string,
                material: MaterialEntity | null,
                orderEntries: MaterialListEntity[],
                entries: MaterialToCommissionEntity[],
            ): MaterialToCommissionData => {
                const m2cs = entries.sort(sortByDateProperty('CreatedAt', false)).map(mapM2c);
                const orderRows = orderEntries.sort(sortByDateProperty('CreatedAt', false)).map((ml) => mapOrder(ml, material));

                const orderedSum = orderEntries.reduce((p, c) => p + (c.Amount || 0), 0);
                const sum = m2cs.reduce((p, c) => p + c.Quantity, 0);   // nur Verbräuche, keine Bestellzeilen
                const costAmountSum = m2cs.reduce((p, c) => p + financialRound(c.Quantity * c.CostAmount), 0);

                const latestDeliveryNote = entries
                    .filter((e) => e.QuantityTypeId && arlMap.get(e.ArlId)?.DocumentType === LedgerImportDocumentTypes.DeliveryNote)
                    .reduce<MaterialToCommissionEntity | null>(
                        (latest, e) => (!latest || new Date(e.CreatedAt).getTime() > new Date(latest.CreatedAt).getTime() ? e : latest),
                        null,
                    );
                const quantityType =
                    (latestDeliveryNote ? quantityTypeMap.get(latestDeliveryNote.QuantityTypeId)?.Name : null) ??
                    (material?.QuantityTypeId ? quantityTypeMap.get(material.QuantityTypeId)?.Name : null) ??
                    null;

                return {
                    MaterialName: materialName?.trim() || '',
                    MaterialId: material?.Id ?? null,
                    ArticleNumber: material?.ArticleNumber ?? null,
                    QuantityType: quantityType,
                    OrderedSum: orderedSum,
                    DeliverySum: sum,
                    m2cs: [...orderRows, ...m2cs].sort((a, b) => a.DateValue - b.DateValue),
                    CostAmountSum: costAmountSum,
                };
            };

            const names = uniqArray([
                ...materialListEntriesWithoutMaterial.map(({ ArlInformation }) => ArlInformation),
                ...materialToCommissionEntriesWithoutMaterial.map((m2c) => arlMap.get(m2c.ArlId)?.Information ?? m2c.Name),
            ]);

            return [
                ...names.map((name) =>
                    buildGroup(
                        name,
                        null,
                        materialListEntriesWithoutMaterial.filter((f) => f.ArlInformation === name),
                        materialToCommissionEntriesWithoutMaterial.filter((m2c) => (arlMap.get(m2c.ArlId)?.Information ?? m2c.Name) === name),
                    ),
                ),
                ...materials.map((material) =>
                    buildGroup(
                        material.Name,
                        material,
                        filteredMaterialList.filter((f) => f.MaterialId === material.Id),
                        filteredMaterialToCommissions.filter((f) => f.MaterialId === material.Id),
                    ),
                ),
            ].sort((a, b) => {
                const diff = (a.m2cs[0]?.DateValue ?? 0) - (b.m2cs[0]?.DateValue ?? 0);
                return diff !== 0 ? diff : a.MaterialName.localeCompare(b.MaterialName);
            });
        }),
        switchMap((data: MaterialToCommissionData[]) =>
            combineLatest([
                this.searchForm.valueChanges.pipe(startWith('')),
                this.SupplierFilterValues$,
            ]).pipe(
                map(([, supplierFilter]) => {
                    const term = (this.searchForm.value || '').trim().toLowerCase();
                    const supplierId = supplierFilter?.[FilterTypes.Customers] ?? null;

                    let result = data;

                    if (supplierId !== null) {
                        result = result
                            .map((d) => {
                                const rows = d.m2cs.filter((r) => r.SupplierId === supplierId);
                                return {
                                    ...d,
                                    m2cs: rows,
                                    OrderedSum: rows.filter((r) => r.IsOrder).reduce((p, c) => p + (c.Quantity || 0), 0),
                                    DeliverySum: rows.filter((r) => !r.IsOrder).reduce((p, c) => p + (c.Quantity || 0), 0),
                                    CostAmountSum: rows.filter((r) => !r.IsOrder).reduce((p, c) => p + financialRound(c.Quantity * c.CostAmount), 0),
                                };
                            })
                            .filter((d) => d.m2cs.length > 0);
                    }

                    if (term) {
                        result = result.filter(
                            (d) =>
                                d.MaterialName?.toLowerCase().includes(term) ||
                                d.m2cs?.some(
                                    (m2c) =>
                                        m2c.ArticleNumber?.toLowerCase().includes(term) ||
                                        m2c.Name?.toLowerCase().includes(term) ||
                                        m2c.Description?.toLowerCase().includes(term),
                                ),
                        );
                    }
                    return result;
                }),
            ),
        ),
        shareReplay({ refCount: true, bufferSize: 1 }),
    );
    getMaterialListDataSource(materialName: string, materialId: number, articleNumber: string | null, fallbackQuantityTypeId: number | null, materialListsByMaterial: MaterialListEntity[]) {
        return combineLatest([getFetched$(this.store, getQuantityTypesFetched, getQuantityTypes), getFetched$(this.store, getUsersFetched, getUserDictionary), this.arlsBase$, this.supplierNameByArlId$]).pipe(
            map(([quantityTypes, users, arls, supplierNames]) => {
                const dataSource = new MatLegacyTableDataSource(
                    materialListsByMaterial.sort(sortByDateProperty('CreatedAt', false)).map((r) => {
                        const quantityType = r.ArlQuantityTypeId ? quantityTypes.find((q) => q.Id === r.ArlQuantityTypeId)?.Name : fallbackQuantityTypeId ? quantityTypes.find((q) => q.Id === fallbackQuantityTypeId)?.Name : null;
                        const arl = arls.find(x => x.Id === r.ArlId);
                        return {
                            MaterialName: materialName?.trim(),
                            MaterialId: materialId,
                            Quantity: r.Amount,
                            QuantityType: quantityType,
                            CreatedAt: formatDate(r.CreatedAt, 'shortDate', 'de-DE'),
                            Status: r?.Status,
                            User: users[r.UserId]?.DisplayName,
                            createdAt: r.CreatedAt.getTime(),
                            ArticleNumber: arl ? arl?.BookingText ?? null : articleNumber ? articleNumber  : null,
                            SupplierName: arl ? supplierNames.get(arl.Id) ?? null : null,
                        };
                    }),
                );
                dataSource.sortingDataAccessor = (object, key: keyof MaterialListData) => {
                    switch (key) {
                        case 'MaterialName':
                            return object.MaterialName || '';
                        case 'ArticleNumber':
                            return object.ArticleNumber || '';
                        case 'SupplierName':
                            return object.SupplierName || '';
                        case 'CreatedAt':
                            return object.createdAt;
                        case 'Quantity':
                            return object[key] || null;
                        default:
                            return object[key] || '';
                    }
                };
                return dataSource;
            }),
            shareReplay({ refCount: true, bufferSize: 1 }),
        );
    }

    toggleSearch() {
        this.searchVisible = !this.searchVisible;
        this.searchForm.setValue('');
        if (this.searchVisible) {
            setTimeout(() => {
                this.searchInput.nativeElement.focus();
            }, 0);
        }
    }

    openDialog() {
        this.dialog.open<MaterialListComponent, MaterialListComponentDialogData>(MaterialListComponent, {
            ...MaterialListComponent.DefaultConfig,
            data: {
                CommissionId: this.commissionId$.value,
            },
        });
    }

    toggleColumn(column: 'Status' | 'User') {
        if (this.visibility[column]) {
            this.MaterialColumns.push(column);
            if (column === 'User') {
                this.MaterialToCommissionColumns = [...this.MaterialToCommissionColumns.slice(0, 2), 'User', ...this.MaterialToCommissionColumns.slice(2)];
            }
        } else {
            this.MaterialColumns = this.MaterialColumns.filter((col) => col !== column);
            if (column === 'User') {
                this.MaterialToCommissionColumns = this.MaterialToCommissionColumns.filter((col) => col !== column);
            }
        }
        this.visibility[column] = !this.visibility[column];
    }

    protected readonly MaterialPageMeta = MaterialPageMeta;

    openNewPopup() {
        this.dialog.open<SelectMaterialPopupComponent, SelectMaterialPopupComponentDialogData>(SelectMaterialPopupComponent, {
            ...SelectMaterialPopupComponent.DefaultConfig,
            data: {
                CommissionId: this.commissionId$.value,
            },
        });
    }
    materialOptions$ = this._materialPageService.selectItems$;
    compareById = (a: SelectSearchOption, b: SelectSearchOption) => a?.Id === b?.Id;
    private async getMaterialToCommissionEditDialogData(m2c?: MaterialToCommissionEntity, materialId?: number,) {
        const mIdForForm = m2c?.MaterialId || materialId;
        let materialForForm: MaterialEntity | null = null;
        if (mIdForForm) {
            materialForForm = await firstValueFrom(this._materialDataService.getMaterialById$(mIdForForm));
        }
        const quantityTypes = await firstValueFrom(getFetched$(this.store, getQuantityTypesFetched, getQuantityTypes));

        const quantityTypeOptions = quantityTypes.map((res) => ({ Id: res.Id, optionLabel: res.Name }));

        this._materialPageService.loadPage({ offset: 0 });
        const materialToCommissionForm = new FormGroup({
            Date: new FormControl<Moment | null>(m2c ? (m2c?.Date ? moment(m2c.Date) : null) : moment(), Validators.required),
            Name: new FormControl<string>(m2c?.Name || null, Validators.required),
            Value: new FormControl<number>(m2c?.Value || null, Validators.required),
            QuantityType: new FormControl<{
                Id: number;
                optionLabel: string;
            } | null>(
                m2c ? (m2c.QuantityTypeId ? quantityTypeOptions.find((o) => o.Id === m2c.QuantityTypeId) : null) : materialForForm ? quantityTypeOptions.find((o) => o.Id === materialForForm.QuantityTypeId) : null,
                Validators.required,
            ),
            Material: new FormControl<MaterialEntity | null>(materialForForm),
        });
        const Properties: IDetailListTemplateDataProperty[] = [
            {
                key: 'Datum',
                formControl: materialToCommissionForm.controls.Date,
                options: {
                    specialInput: {
                        date: true,
                    },
                },
            },
            {
                key: 'Bezeichnung',
                formControl: materialToCommissionForm.controls.Name,
            },
            {
                key: MaterialEntity.EntityName,
                formControl: materialToCommissionForm.controls.Material,
                hideFormControl: !!mIdForForm,
                options: {
                    specialInput: {
                        // singleSelectSearch: {
                        //     options: materialOptions,
                        //     compareOptions: (a, b) => a?.Id === b?.Id,
                        // },
                        customTemplate: this.pagedSelectTest,
                    },
                },
            },
            {
                key: 'Menge',
                formControl: materialToCommissionForm.controls.Value,
                options: {
                    specialInput: {
                        number: true,
                    },
                },
            },
            {
                key: 'Einheit',
                formControl: materialToCommissionForm.controls.QuantityType,
                options: {
                    specialInput: {
                        singleSelectSearch: {
                            options: quantityTypeOptions,
                            compareOptions: (a, b) => a?.Id === b?.Id,
                        },
                    },
                },
            },
        ];
        return { Properties, materialToCommissionForm };
    }
    editMaterialToCommission(m2cId: number) {
        firstValueFrom(this.store.select(getMaterialToCommissionById({ id: m2cId })))
            .then((m2c) => {
                return this.getMaterialToCommissionEditDialogData(m2c);
            })
            .then(({ Properties, materialToCommissionForm }) => {
                this.dialog
                    .open<DetailListTemplateDialogComponent, DetailListTemplateDialogData, DetailListDialogReturn>(DetailListTemplateDialogComponent, {
                        ...DetailListTemplateDialogComponent.DefaultConfig,
                        width: '25rem',
                        data: {
                            DisableSaveButton$: materialToCommissionForm.statusChanges.pipe(
                                startWith(materialToCommissionForm.status),
                                map((state) => state !== 'VALID'),
                            ),
                            Data: {
                                Headline: 'Materialverbrauch bearbeiten',
                                Properties,
                            },
                            DeleteButton: true,
                            Editing: true,
                        },
                    })
                    .afterClosed()
                    .subscribe((ret) => {
                        if (ret?.Action === 'save') {
                            this.store.dispatch(
                                MaterialToCommissionActionTypes.Change({
                                    Payload: {
                                        Id: m2cId.toString(),
                                        Date: GetTimestampFromTime(materialToCommissionForm.value.Date.toDate()) + '',
                                        Name: materialToCommissionForm.value.Name,
                                        Value: materialToCommissionForm.value.Value,
                                        QuantityTypeId: materialToCommissionForm.value.QuantityType?.Id ? materialToCommissionForm.value.QuantityType.Id.toString() : null,
                                    },
                                }),
                            );
                        } else if (ret?.Action === 'delete') {
                            this.store.dispatch(
                                MaterialToCommissionActionTypes.Delete({
                                    Payload: {
                                        Id: m2cId.toString(),
                                    },
                                }),
                            );
                        }
                    });
            });
    }

    createMaterialToCommission(element?: Pick<MaterialToCommissionData, 'MaterialId' | 'MaterialName'>) {
        this.getMaterialToCommissionEditDialogData(null, element?.MaterialId).then(({ Properties, materialToCommissionForm }) => {
            this.dialog
                .open<DetailListTemplateDialogComponent, DetailListTemplateDialogData, DetailListDialogReturn>(DetailListTemplateDialogComponent, {
                    ...DetailListTemplateDialogComponent.DefaultConfig,
                    width: '25rem',
                    data: {
                        DisableSaveButton$: materialToCommissionForm.statusChanges.pipe(
                            startWith(materialToCommissionForm.status),
                            map((state) => state !== 'VALID'),
                        ),
                        Data: {
                            Headline: element?.MaterialName ? 'Verbrauch von ' + element.MaterialName + ' anlegen' : 'Materialverbrauch anlegen',
                            Properties,
                        },
                        DeleteButton: false,
                        Editing: true,
                    },
                })
                .afterClosed()
                .subscribe((ret) => {
                    if (ret?.Action === 'save') {
                        this.store.dispatch(
                            MaterialToCommissionActionTypes.Create({
                                Payload: {
                                    CommissionId: this.commissionId$.value.toString(),
                                    MaterialId: element?.MaterialId ? element.MaterialId.toString() : materialToCommissionForm.value.Material?.Id.toString(),
                                    Date: GetTimestampFromTime(materialToCommissionForm.value.Date.toDate()) + '',
                                    Name: materialToCommissionForm.value.Name,
                                    Value: materialToCommissionForm.value.Value,
                                    QuantityTypeId: materialToCommissionForm.value.QuantityType?.Id ? materialToCommissionForm.value.QuantityType.Id.toString() : null,
                                },
                            }),
                        );
                    }
                });
        });
    }

    materialOptionsSearchChange(searchQuery: string, matPaginator: MatPaginator) {
        this._materialPageService.setSearch(searchQuery).then(() => {
            this._materialPageService.loadPage({ offset: 0 });
            matPaginator.pageIndex = 0;
        });
    }

    materialOptionsPageChange(page: PageEvent) {
        this._materialPageService.loadPage({
            offset: page.pageIndex * page.pageSize,
        });
    }
    NewReport(booked: boolean) {
        firstValueFrom(this.commissionId$)
            .then((commissionId) => firstValueFrom(this.store.select(getCommissionById({ id: commissionId }))))
            .then((commission) => {
                if (commission) {
                    this.createArlFromCommissionService.NewReport(true, booked, commission.Id, true, commission?.CustomerId);
                }
            });
        this.dialog.closeAll();
    }

    pageSize$ = this._materialPageService.selectPageSize$;
    protected readonly MaterialEntity = MaterialEntity;
    materialListTabIsActive = MATERIAL_LIST_TAB_INDEX === 0;
    deliveryNoteTabIsActive = false;
    onTabChange($event: MatTabChangeEvent) {
        this.materialListTabIsActive = MATERIAL_LIST_TAB_INDEX === $event.index;
        this.deliveryNoteTabIsActive = DELIVERYNOTE_LIST_TAB_INDEX === $event.index;
    }

    protected readonly ReportsPageMeta = ReportsPageMeta;

    protected readonly formatCurrency = formatCurrency;

    async PrintMaterialToCommissions(orientation: 'portrait' | 'landscape' = 'landscape') {
        const portrait = orientation === 'portrait';
        const [data, supplierLabel, commission] = await Promise.all([
            firstValueFrom(this.materialToCommissions$),
            firstValueFrom(this.cls.getSingle$('Supplier')),
            firstValueFrom(this.store.select(getCommissionById({ id: this.commissionId$.value }))),
        ]);

        const esc = (value: unknown) =>
            value === null || value === undefined
                ? ''
                : String(value).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
        const num = (value: number) => (value === null || value === undefined ? '' : formatNumber(value, 'de-DE', '1.0-3'));
        const cur = (value: number) => formatCurrency(value || 0, 'de-DE', '€', 'EUR');


        type PrintColumn = { key: keyof MaterialToCommissionTableData; label: string; weight: number; num?: boolean; render: (r: MaterialToCommissionTableData) => string; footer?: (m: MaterialToCommissionData) => string };
        const columnDefs: { [key: string]: PrintColumn } = {
            ArticleNumber: { key: 'ArticleNumber', label: 'Art-Nr.', weight: 10, render: (r) => esc(r.ArticleNumber) },
            Description: { key: 'Description', label: 'Bezeichnung', weight: 22, render: (r) => esc(r.Description) },
            Name: { key: 'Name', label: 'Nummer', weight: 10, render: (r) => esc(r.Name) },
            User: { key: 'User', label: 'Bearbeiter', weight: 10, render: (r) => esc(r.User) },
            Date: { key: 'Date', label: 'Datum', weight: 8, render: (r) => esc(r.Date) },
            Quantity: { key: 'Quantity', label: 'Menge', weight: 7, num: true, render: (r) => num(r.Quantity), footer: (m) => `<strong>${num(m.DeliverySum)}</strong>` },
            QuantityType: { key: 'QuantityType', label: 'Einheit', weight: 6, render: (r) => esc(r.QuantityType), footer: (m) => esc(m.QuantityType) },
            DocumentType: { key: 'DocumentType', label: 'Dokumentenart', weight: 12, render: (r) => esc(r.DocumentType) },
            SupplierName: { key: 'SupplierName', label: esc(supplierLabel), weight: 13, render: (r) => esc(r.SupplierName) },
            CostAmount: { key: 'CostAmount', label: 'EK-Preis', weight: 9, num: true, render: (r) => cur(r.CostAmount) },
            CostAmountSum: { key: 'CostAmountSum', label: 'Summe', weight: 10, num: true, render: (r) => cur(r.CostAmountSum), footer: (m) => `<strong>${cur(m.CostAmountSum)}</strong>` },
        };
        const columns = this.MaterialToCommissionColumns.map((c) => columnDefs[c]).filter(isNotNullOrUndefined);
        const totalWeight = columns.reduce((p, c) => p + c.weight, 0) || 1;
        const colgroup = `<colgroup>${columns.map((c) => `<col style="width: ${((c.weight / totalWeight) * 100).toFixed(2)}%">`).join('')}</colgroup>`;

        const activeFilters: string[] = [];
        const searchTerm = (this.searchForm.value || '').trim();
        if (searchTerm) {
            activeFilters.push(`Suche: „${esc(searchTerm)}“`);
        }
        const supplierId = this.SupplierFilterValues$.value?.[FilterTypes.Customers] ?? null;
        if (supplierId !== null) {
            const supplierName = data.flatMap((d) => d.m2cs).find((r) => r.SupplierId === supplierId)?.SupplierName;
            activeFilters.push(`${esc(supplierLabel)}: ${esc(supplierName ?? supplierId)}`);
        }

        const totalCost = data.reduce((p, c) => p + (c.CostAmountSum || 0), 0);
        const commissionName = commission?.GetDisplayName?.() || commission?.Auftragsnummer || '';

        const blocks = data
            .map((m) => {
                const header = `<div class="article-header">${m.ArticleNumber ? `<span class="article-number">${esc(m.ArticleNumber)}</span> ` : ''}<strong>${esc(m.MaterialName)}</strong><span class="sum">${num(m.DeliverySum)} / ${num(m.OrderedSum)}</span></div>`;
                const head = `<tr>${columns.map((c) => `<th${c.num ? ' class="num"' : ''}>${c.label}</th>`).join('')}</tr>`;
                const rows = m.m2cs.length
                    ? m.m2cs.map((r) => `<tr${r.IsOrder ? ' class="order"' : ''}>${columns.map((c) => `<td${c.num ? ' class="num"' : ''}>${c.render(r)}</td>`).join('')}</tr>`).join('')
                    : `<tr><td colspan="${columns.length}">Keine Materialverbräuche vorhanden</td></tr>`;
                const foot = `<tr class="result-row">${columns.map((c, i) => `<td${c.num ? ' class="num"' : ''}>${i === 0 ? '<strong>Ergebnis</strong>' : c.footer ? c.footer(m) : ''}</td>`).join('')}</tr>`;
                return `<section>${header}<table>${colgroup}<thead>${head}</thead><tbody>${rows}</tbody><tfoot>${foot}</tfoot></table></section>`;
            })
            .join('');

        const html = `<!DOCTYPE html><html lang="de"><head><meta charset="utf-8"><title>Verbrauchtes Material${commissionName ? ' - ' + esc(commissionName) : ''}</title>
<style>
    @page { size: A4 ${portrait ? 'portrait' : 'landscape'}; margin: ${portrait ? '10mm' : '12mm'}; }
    html, body { width: 100%; }
    body { font-family: Arial, Helvetica, sans-serif; font-size: ${portrait ? '8pt' : '10pt'}; color: #000; margin: 0; -webkit-print-color-adjust: exact; print-color-adjust: exact; }
    th, td { overflow-wrap: anywhere; word-break: break-word; }
    h1 { font-size: 14pt; margin: 0 0 4px 0; }
    .meta { margin-bottom: 12px; color: #444; }
    section { margin-bottom: 14px; page-break-inside: avoid; }
    .article-header { display: flex; gap: 8px; align-items: baseline; border-bottom: 1px solid #000; padding: 2px 0; margin-bottom: 2px; }
    .article-header .sum { margin-left: auto; }
    .article-number { color: #444; }
    table { width: 100%; border-collapse: collapse; table-layout: fixed; }
    th, td { text-align: left; padding: 2px 4px; border-bottom: 1px solid #ddd; vertical-align: top; }
    th { border-bottom: 1px solid #888; }
    .num { text-align: right; white-space: nowrap; }
    tr.order td { color: #555; font-style: italic; }
    .result-row td { border-top: 1px solid #888; border-bottom: none; }
    thead { display: table-header-group; }
    .total { margin-top: 8px; text-align: right; font-size: 11pt; }
</style></head><body>
<h1>Verbrauchtes Material${commissionName ? ' – ' + esc(commissionName) : ''}</h1>
<div class="meta">Stand: ${esc(formatDate(new Date(), 'short', 'de-DE'))}${activeFilters.length ? ' &middot; Filter: ' + activeFilters.join(', ') : ''}</div>
${data.length ? blocks : '<p>kein verbrauchtes Material vorhanden</p>'}
</body></html>`;

        const iframe = document.createElement('iframe');
        iframe.style.position = 'fixed';
        iframe.style.right = '0';
        iframe.style.bottom = '0';
        iframe.style.width = '0';
        iframe.style.height = '0';
        iframe.style.border = '0';
        document.body.appendChild(iframe);
        const doc = iframe.contentWindow.document;
        doc.open();
        doc.write(html);
        doc.close();
        const cleanup = () => setTimeout(() => iframe.remove(), 0);
        iframe.contentWindow.addEventListener('afterprint', cleanup);
        setTimeout(() => {
            iframe.contentWindow.focus();
            iframe.contentWindow.print();
            setTimeout(() => iframe.isConnected && iframe.remove(), 60000);
        }, 100);
    }
}
